import React from "react";
import { template } from "@reco-m/core";
import { ViewComponent } from "@reco-w/core-ui";
import { Namespaces, footerModel } from "@reco-w/policy-layout-models";
import { Row, Col } from "antd";

export namespace PageFooter {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, footerModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.footer;

        render() {
            return (
                <div className="footer">
                    <div className="container">
                        <div className={"flex footer-content"}>
                            {/*<img src={"assets/images/waiter/footer-logo.png"}/>*/}
                            <div className="text flex-item">
                                <Row align="middle">
                                    <Col span={10}>联系地址：上海市纳贤路800号 科海大楼B区 8楼 888室</Col>
                                    <Col span={7}>联系电话：13003223873</Col>
                                    <Col span={7}>邮箱：pcoic@pcoic.org.cn</Col>
                                </Row>
                            </div>
                        </div>
                        <div className="footer-desc">Copyright @2019 National Quality Foundation Comprehensive Appli</div>
                    </div>
                </div>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.footer]);
}
